import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import SectionLabel from '@/components/ui/SectionLabel'
import PredicationCard from './PredicationCard'
import { DERNIERES_PREDICATIONS } from '@/data/predications'

export default function PredicationSection() {
  return (
    <section id="predication" className="py-16 md:py-20 px-4 bg-cmp-cream">
      <div className="max-w-lg md:max-w-5xl mx-auto">
        <SectionLabel>Prédications</SectionLabel>
        <h2 className="text-2xl md:text-3xl font-bold text-cmp-navy text-center mt-3 mb-8 md:mb-10">
          Nos dernières prédications
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {DERNIERES_PREDICATIONS.map((predication) => (
            <PredicationCard key={predication.id} {...predication} />
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/predications"
            className="inline-flex items-center gap-1.5 text-cmp-blue font-semibold text-sm hover:gap-2.5 transition-all"
          >
            Toutes les prédications
            <ChevronRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  )
}
